/**
 * Inscription newsletter sans rechargement de page.
 *
 * Le formulaire reste celui de Shopify ({% form 'customer' %}) : meme adresse,
 * meme traitement, meme e-mail de confirmation. Il est simplement envoye en
 * arriere-plan, puis la reponse est lue pour savoir si l inscription est passee.
 * Sans fetch, ou si la reponse est illisible, l envoi classique reprend la main :
 * aucune inscription ne peut se perdre.
 */
(function () {
  if (window.__newsletterAjax) return;
  window.__newsletterAjax = true;

  function messageErreur(doc) {
    var el = doc.querySelector('.nlmodal__message--error, .nlband__message--error');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form.newsletter-ajax') : null;
    if (!form) return;
    if (!window.fetch || !window.FormData || !window.DOMParser) return; // envoi classique
    if (form.dataset.envoiEnCours === '1') {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    form.dataset.envoiEnCours = '1';

    var message = form.querySelector('[data-nl-message]');
    var ligne = form.querySelector('[data-nl-row]');
    var bouton = form.querySelector('[type="submit"]');
    if (bouton) bouton.disabled = true;
    if (message) {
      message.hidden = true;
      if (message.dataset.errorClass) message.classList.remove(message.dataset.errorClass);
    }

    var fini = function () {
      form.dataset.envoiEnCours = '0';
      if (bouton) bouton.disabled = false;
    };

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
    })
      .then(function (r) {
        return r.text().then(function (html) {
          return { url: r.url || '', html: html };
        });
      })
      .then(function (reponse) {
        var doc = new DOMParser().parseFromString(reponse.html, 'text/html');
        var reussi =
          reponse.url.indexOf('customer_posted=true') !== -1 || !!doc.querySelector('[data-nl-posted]');

        if (reussi) {
          if (ligne) ligne.hidden = true;
          form.querySelectorAll('[data-nl-hide-on-success]').forEach(function (el) {
            el.hidden = true;
          });
          if (message) {
            message.textContent = message.dataset.success || '';
            message.hidden = false;
          }
          form.dispatchEvent(new CustomEvent('newsletter:inscrit', { bubbles: true }));
          fini();
          return;
        }

        var erreur = messageErreur(doc);
        if (!erreur) {
          // Reponse inattendue : on repasse par l envoi classique, Shopify
          // affichera lui-meme ce qui ne va pas.
          form.submit();
          return;
        }

        if (message) {
          message.textContent = erreur;
          if (message.dataset.errorClass) message.classList.add(message.dataset.errorClass);
          message.hidden = false;
        }
        fini();
      })
      .catch(function () {
        // Reseau coupe ou requete bloquee : envoi classique
        form.submit();
      });
  });
})();
